<div class="form-container">
  <!-- Sidebar Navigation -->
  <div class="sidebar">
    <ul>
      <li
        [class.active]="currentStep === 1"
        [class.completed]="currentStep > 1"
      >
        General Information
      </li>
      <li
        [class.active]="currentStep === 2"
        [class.completed]="currentStep > 2"
      >
        Business Information
      </li>
      <li
        [class.active]="currentStep === 3"
        [class.completed]="currentStep > 3"
      >
        Point of Contact
      </li>
      <li
        [class.active]="currentStep === 4"
        [class.completed]="currentStep > 4"
      >
        Notification Settings
      </li>
      <li
        [class.active]="currentStep === 5"
        [class.completed]="currentStep > 5"
      >
        Messaging Service Configuration
      </li>
      <li
        [class.active]="currentStep === 6"
        [class.completed]="currentStep > 6"
      >
        Brand Registration Settings
      </li>
      <li
        [class.active]="currentStep === 7"
        [class.completed]="currentStep > 7"
      >
        A2P Campaign Configuration
      </li>
      <li
        [class.active]="currentStep === 8"
        [class.completed]="currentStep > 8"
      >
        Terms of Service and Privacy Policy
      </li>
    </ul>
  </div>

  <!-- Main Content Area -->
  <div class="main-content">
    <h2>Create Your Business Profile</h2>

    <div class="form-content" #formContent>
      <!-- Step 1: General Information -->
      <div *ngIf="currentStep === 1">
        <h3>General Information</h3>
        <label>Legal Business Name <span class="required-star">*</span></label>
        <input
          name="legalBusinessName"
          [(ngModel)]="legalBusinessName"
          placeholder="Enter the exact legal business name"
          required
        />
        <div
          *ngIf="nextButtonPressed && errors['legalBusinessName']"
          class="error-message"
        >
          {{ errors["legalBusinessName"] }}
        </div>

        <label
          >Profile Friendly Name <span class="required-star">*</span></label
        >
        <input
          name="profileFriendlyName"
          [(ngModel)]="profileFriendlyName"
          placeholder="Profile friendly name"
          required
        />
        <div
          *ngIf="nextButtonPressed && errors['profileFriendlyName']"
          class="error-message"
        >
          {{ errors["profileFriendlyName"] }}
        </div>

        <label
          >Physical Business Address <span class="required-star">*</span></label
        >
        <select name="country" [(ngModel)]="country" required>
          <option value="">Select a country</option>
          <option *ngFor="let country of countries" [value]="country.code">
            {{ country.name }}
          </option>
        </select>
        <div
          *ngIf="nextButtonPressed && errors['country']"
          class="error-message"
        >
          {{ errors["country"] }}
        </div>

        <label>Address Street 1 <span class="required-star">*</span></label>
        <input
          name="street1"
          [(ngModel)]="street1"
          placeholder="Address Street 1"
          required
        />
        <div
          *ngIf="nextButtonPressed && errors['street1']"
          class="error-message"
        >
          {{ errors["street1"] }}
        </div>

        <label>Address Street 2</label>
        <input
          name="street2"
          [(ngModel)]="street2"
          placeholder="Address Street 2"
        />

        <label>City <span class="required-star">*</span></label>
        <input name="city" [(ngModel)]="city" placeholder="City" required />
        <div *ngIf="nextButtonPressed && errors['city']" class="error-message">
          {{ errors["city"] }}
        </div>

        <label>State or Province <span class="required-star">*</span></label>
        <input
          name="state"
          [(ngModel)]="state"
          placeholder="State or Province"
          required
        />
        <div *ngIf="nextButtonPressed && errors['state']" class="error-message">
          {{ errors["state"] }}
        </div>

        <label>Postal Code <span class="required-star">*</span></label>
        <input
          name="postalCode"
          [(ngModel)]="postalCode"
          placeholder="Postal Code"
          required
        />
        <div
          *ngIf="nextButtonPressed && errors['postalCode']"
          class="error-message"
        >
          {{ errors["postalCode"] }}
        </div>
      </div>

      <!-- Step 2: Business Information -->
      <div *ngIf="currentStep === 2">
        <h3>Please Provide Your Business Information</h3>
        <label>Business Type <span class="required-star">*</span></label>
        <select name="businessType" [(ngModel)]="businessType" required>
          <option value="">Select Business Type</option>
          <option value="Sole Proprietorship">Sole Proprietorship</option>
          <option value="Partnership">Partnership</option>
          <option value="Limited Liability Corporation">
            Limited Liability Corporation
          </option>
          <option value="Co-operative">Co-operative</option>
          <option value="Non-profit Corporation">Non-profit Corporation</option>
          <option value="Corporation">Corporation</option>
        </select>
        <div
          *ngIf="nextButtonPressed && errors['businessType']"
          class="error-message"
        >
          {{ errors["businessType"] }}
        </div>

        <label>Business Industry <span class="required-star">*</span></label>
        <select name="businessIndustry" [(ngModel)]="businessIndustry" required>
          <option value="">Select Industry</option>
          <option
            *ngFor="let industry of businessIndustries"
            [value]="industry"
          >
            {{ industry }}
          </option>
        </select>
        <div
          *ngIf="nextButtonPressed && errors['businessIndustry']"
          class="error-message"
        >
          {{ errors["businessIndustry"] }}
        </div>

        <label
          >Business Registration ID Type
          <span class="required-star">*</span></label
        >
        <select
          name="registrationIdType"
          [(ngModel)]="registrationIdType"
          required
        >
          <option value="">Select ID Type</option>
          <option *ngFor="let type of idTypes" [ngValue]="type.code">
            {{ type.name }}
          </option>
        </select>
        <div
          *ngIf="nextButtonPressed && errors['registrationIdType']"
          class="error-message"
        >
          {{ errors["registrationIdType"] }}
        </div>

        <label
          >Business Registration Number
          <span class="required-star">*</span></label
        >
        <input
          name="registrationNumber"
          [(ngModel)]="registrationNumber"
          placeholder="e.g., 12-3456789 for US:EIN"
          required
        />
        <div
          *ngIf="nextButtonPressed && errors['registrationNumber']"
          class="error-message"
        >
          {{ errors["registrationNumber"] }}
        </div>

        <label
          >Business Regions of Operations
          <span class="required-star">*</span></label
        >
        <div>
          <label
            ><input type="checkbox" [(ngModel)]="regions.africa" />
            Africa</label
          >
          <label
            ><input type="checkbox" [(ngModel)]="regions.asia" /> Asia</label
          >
          <label
            ><input type="checkbox" [(ngModel)]="regions.australia" />
            Australia</label
          >
          <label
            ><input type="checkbox" [(ngModel)]="regions.europe" />
            Europe</label
          >
          <label
            ><input type="checkbox" [(ngModel)]="regions.latinAmerica" /> Latin
            America</label
          >
          <label
            ><input type="checkbox" [(ngModel)]="regions.usaCanada" /> USA and
            Canada</label
          >
        </div>
        <div
          *ngIf="nextButtonPressed && errors['regions']"
          class="error-message"
        >
          {{ errors["regions"] }}
        </div>

        <label>Business Website <span class="required-star">*</span></label>
        <input
          name="businessWebsite"
          [(ngModel)]="businessWebsite"
          placeholder="https://"
          required
        />
        <div
          *ngIf="nextButtonPressed && errors['businessWebsite']"
          class="error-message"
        >
          {{ errors["businessWebsite"] }}
        </div>
      </div>

      <!-- Step 3: Point of Contact -->
      <div *ngIf="currentStep === 3">
        <h3>Point of Contact</h3>
        <label>First Name <span class="required-star">*</span></label>
        <input name="repFirstName" [(ngModel)]="repFirstName" required />
        <div
          *ngIf="nextButtonPressed && errors['repFirstName']"
          class="error-message"
        >
          {{ errors["repFirstName"] }}
        </div>

        <label>Last Name <span class="required-star">*</span></label>
        <input name="repLastName" [(ngModel)]="repLastName" required />
        <div
          *ngIf="nextButtonPressed && errors['repLastName']"
          class="error-message"
        >
          {{ errors["repLastName"] }}
        </div>

        <label>Email <span class="required-star">*</span></label>
        <input name="repEmail" [(ngModel)]="repEmail" type="email" required />
        <div
          *ngIf="nextButtonPressed && errors['repEmail']"
          class="error-message"
        >
          {{ errors["repEmail"] }}
        </div>

        <label>Phone Number <span class="required-star">*</span></label>
        <div class="phone-input-group">
          <select
            [(ngModel)]="selectedPhoneCountry"
            name="phoneCountry"
            [compareWith]="compareCountries"
          >
            <option *ngFor="let country of countries" [ngValue]="country">
              {{ country.prefix }} ({{ country.name }})
            </option>
          </select>
          <input
            name="repPhone"
            [(ngModel)]="repPhone"
            required
            placeholder="Enter phone number"
          />
        </div>
        <div
          *ngIf="nextButtonPressed && errors['repPhone']"
          class="error-message"
        >
          {{ errors["repPhone"] }}
        </div>

        <label>Business Title <span class="required-star">*</span></label>
        <input name="businessTitle" [(ngModel)]="businessTitle" required />
        <div
          *ngIf="nextButtonPressed && errors['businessTitle']"
          class="error-message"
        >
          {{ errors["businessTitle"] }}
        </div>

        <label>Job Position <span class="required-star">*</span></label>
        <select name="repJobPosition" [(ngModel)]="repJobPosition" required>
          <option value="">Select Job Position</option>
          <option value="Director">Director</option>
          <option value="GM">GM</option>
          <option value="VP">VP</option>
          <option value="CEO">CEO</option>
          <option value="CFO">CFO</option>
          <option value="General Counsel">General Counsel</option>
          <option value="Other">Other</option>
        </select>
        <div
          *ngIf="nextButtonPressed && errors['repJobPosition']"
          class="error-message"
        >
          {{ errors["repJobPosition"] }}
        </div>
      </div>

      <!-- Step 4: Notification Settings -->
      <div *ngIf="currentStep === 4">
        <h3>Notification Settings</h3>
        <p>
          We will use these details to notify recipients about the status of
          this Business Profile.
        </p>
        <label>Email Address <span class="required-star">*</span></label>
        <input
          name="notificationEmail"
          [(ngModel)]="notificationEmail"
          type="email"
          required
        />
        <div
          *ngIf="nextButtonPressed && errors['notificationEmail']"
          class="error-message"
        >
          {{ errors["notificationEmail"] }}
        </div>
      </div>

      <!-- Step 5: Messaging Service Configuration -->
      <div *ngIf="currentStep === 5">
        <h3>Messaging Service Configuration</h3>
        <p>
          Provide the webhook URLs for handling inbound messages and fallback
          scenarios.
        </p>
        <label>Friendly Name (optional)</label>
        <input
          name="messagingFriendlyName"
          [(ngModel)]="messagingFriendlyName"
          placeholder="e.g., Your Company's Messaging Service"
        />
        <p class="info-text">
          If not provided, a default name will be generated using your legal
          business name.
        </p>

        <label>Inbound Request URL <span class="required-star">*</span></label>
        <input
          name="inboundRequestUrl"
          [(ngModel)]="inboundRequestUrl"
          type="url"
          placeholder="https://yourdomain.com/inbound-messages-webhook"
          required
        />
        <div
          *ngIf="nextButtonPressed && errors['inboundRequestUrl']"
          class="error-message"
        >
          {{ errors["inboundRequestUrl"] }}
        </div>
        <p class="info-text">This URL will receive inbound message webhooks.</p>

        <label>Fallback URL <span class="required-star">*</span></label>
        <input
          name="fallbackUrl"
          [(ngModel)]="fallbackUrl"
          type="url"
          placeholder="https://yourdomain.com/fallback"
          required
        />
        <div
          *ngIf="nextButtonPressed && errors['fallbackUrl']"
          class="error-message"
        >
          {{ errors["fallbackUrl"] }}
        </div>
        <p class="info-text">
          This URL will be used as a fallback for error handling or retries.
        </p>
      </div>

      <!-- Step 6: Brand Registration Settings -->
      <div *ngIf="currentStep === 6">
        <h3>Brand Registration Settings</h3>
        <label>Brand Contact Email <span class="required-star">*</span></label>
        <input
          name="brandEmail"
          [(ngModel)]="brandEmail"
          type="email"
          required
        />
        <div
          *ngIf="nextButtonPressed && errors['brandEmail']"
          class="error-message"
        >
          {{ errors["brandEmail"] }}
        </div>
        <p class="info-text">
          This email will receive Two-Factor Authentication (2FA) emails from
          Twilio for brand registration.
        </p>
      </div>

      <!-- Step 7: A2P Campaign Configuration -->
      <div *ngIf="currentStep === 7">
        <h3>A2P Campaign Configuration</h3>

        <!-- Status Messages -->
        <div
          *ngIf="
            !useCases.length &&
            !(
              brandStatus === 'rejected' ||
              brandStatus === 'registration_failed'
            )
          "
          class="status-message status-waiting"
        >
          Waiting for available use cases to be fetched...
        </div>

        <!-- Rejection message - Takes priority over loading message -->
        <div
          *ngIf="
            brandStatus === 'rejected' || brandStatus === 'registration_failed'
          "
          class="rejection-message"
        >
          <div class="warning-header">
            <h3 class="warning-title">Brand Registration Failed</h3>
          </div>
          <div class="warning-content">
            <p class="warning-reason">
              <strong>Reason:</strong>
              {{
                "Some details may be incorrect. Please review your information."
              }}
            </p>
            <p class="warning-instruction">
              To proceed, please log out and sign up again to resubmit your
              details.
            </p>
          </div>
          <div class="warning-actions">
            <button (click)="reloginAndRedirect()" class="logout-btn">
              <span class="btn-icon">↻</span>
              Log Out & Restart
            </button>
          </div>
        </div>

        <!-- Always visible form -->
        <div class="campaign-form">
          <p>Configure your A2P Campaign to comply with 10DLC requirements.</p>

          <label for="useCase"
            >Use Case <span class="required-star">*</span></label
          >
          <select
            name="useCase"
            [(ngModel)]="selectedUseCase"
            id="useCase"
            required
            [disabled]="!useCases.length"
          >
            <option value="">Select a Use Case</option>
            <option *ngFor="let useCase of useCases" [value]="useCase.code">
              {{ useCase.name }}
            </option>
          </select>
          <div
            *ngIf="nextButtonPressed && errors['selectedUseCase']"
            class="error-message"
          >
            {{ errors["selectedUseCase"] }}
          </div>

          <label for="campaignDescription"
            >Campaign Description <span class="required-star">*</span></label
          >
          <textarea
            name="campaignDescription"
            [(ngModel)]="campaignDescription"
            id="campaignDescription"
            placeholder="Describe your campaign purpose, target audience, and messaging strategy"
            required
          ></textarea>
          <div
            *ngIf="nextButtonPressed && errors['campaignDescription']"
            class="error-message"
          >
            {{ errors["campaignDescription"] }}
          </div>

          <div class="message-samples-section">
            <label
              >Message Samples (at least 2 required)
              <span class="required-star">*</span></label
            >
            <div class="message-samples-container">
              <div
                *ngFor="
                  let sample of messageSamples;
                  let i = index;
                  trackBy: trackByIndex
                "
                class="message-sample-item"
              >
                <input
                  [id]="'messageSample' + i"
                  name="messageSample{{ i }}"
                  [ngModel]="messageSamples[i]"
                  (ngModelChange)="updateMessageSample(i, $event)"
                  type="text"
                  [placeholder]="getMessageSamplePlaceholder(i)"
                  required
                />
                <div
                  *ngIf="nextButtonPressed && errors['messageSamples' + i]"
                  class="error-message"
                >
                  {{ errors["messageSamples" + i] }}
                </div>
                <button
                  *ngIf="messageSamples.length > 2"
                  type="button"
                  class="remove-sample-btn"
                  (click)="removeMessageSample(i)"
                >
                  Remove
                </button>
              </div>
            </div>
            <button
              type="button"
              class="add-sample-btn"
              (click)="addMessageSample()"
              [disabled]="messageSamples.length >= 5"
            >
              + Add Message Sample
            </button>
            <div
              *ngIf="nextButtonPressed && errors['messageSamples']"
              class="error-message"
            >
              {{ errors["messageSamples"] }}
            </div>
          </div>

          <label for="messageFlow"
            >Message Flow <span class="required-star">*</span></label
          >
          <textarea
            name="messageFlow"
            [(ngModel)]="messageFlow"
            id="messageFlow"
            placeholder="Describe how users opt-in to receive messages (e.g., via website signup, SMS keyword, app registration)"
            required
          ></textarea>
          <div
            *ngIf="nextButtonPressed && errors['messageFlow']"
            class="error-message"
          >
            {{ errors["messageFlow"] }}
          </div>

          <div class="checkbox-group">
            <div class="checkbox-item">
              <input
                type="checkbox"
                [(ngModel)]="hasEmbeddedLinks"
                id="hasEmbeddedLinks"
              />
              <label for="hasEmbeddedLinks"
                >Messages Contain Embedded Links</label
              >
            </div>
            <div class="checkbox-item">
              <input
                type="checkbox"
                [(ngModel)]="hasEmbeddedPhone"
                id="hasEmbeddedPhone"
              />
              <label for="hasEmbeddedPhone"
                >Messages Contain Embedded Phone Numbers</label
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Step 8: Terms of Service and Privacy Policy -->
      <div *ngIf="currentStep === 8">
        <h3>Terms of Service and Privacy Policy</h3>
        <div class="terms-checkbox">
          <label>
            <input type="checkbox" [(ngModel)]="acceptTerms" required />
            <span
              >I accept the terms of service and privacy policy.
              <span class="required-star">*</span></span
            >
          </label>
          <div
            *ngIf="nextButtonPressed && errors['acceptTerms']"
            class="error-message"
          >
            {{ errors["acceptTerms"] }}
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Buttons -->
    <div class="navigation-buttons">
      <div class="nav-buttons-left">
        <button
          *ngIf="currentStep > 1 && currentStep !== 7"
          (click)="goBack()"
          class="back-btn"
          [disabled]="isNavigationDisabled()"
        >
          Back
        </button>
        <button (click)="saveDraft()" class="save-draft-btn">Save Draft</button>
      </div>
      <div class="nav-buttons-right">
        <button
          *ngIf="currentStep < totalSteps"
          (click)="proceedToNextStep()"
          class="next-btn"
          [disabled]="isNavigationDisabled()"
        >
          Next
        </button>
        <button
          *ngIf="currentStep === totalSteps"
          (click)="submitOnboarding()"
          class="submit-btn"
        >
          <span *ngIf="isLoading" class="spinner"></span>
          {{ isLoading ? "Submitting..." : "Submit" }}
        </button>
      </div>
    </div>
  </div>
</div>
